import { Alert, FormControl, Grid, TextField } from '@mui/material'

import {
    CustomAutocomplete,
    LinearLoading
} from '../../../../../../../common'

import { SlipSection } from './SlipSection'

export const ServicePayment = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange, onInputNumberChange, } = FormScreen

    const servicePaymentLimit = parseFloat(formState.limite_pago_servicio)
    const requiresAdministrativeApproval = parseFloat(formState.monto_solicitado) > servicePaymentLimit

    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="descripcion_servicio"> * Servicio</label>
                        <TextField
                            id='descripcion_servicio'
                            name='descripcion_servicio'
                            value={ formState.descripcion_servicio } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Descripción del servicio'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="monto_solicitado"> * Monto a Trasladar</label>
                        <TextField
                            id='monto_solicitado'
                            name='monto_solicitado'
                            value={ formState.monto_solicitado_mask } 
                            onChange={ onInputNumberChange }
                            size='small'
                            placeholder='500.50, 100.00'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            {(requiresAdministrativeApproval) && (
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <Alert severity='warning'>
                        Se solicita autorización administrativa porque el monto a desembolsar supera el límite permitido de <b>Q. 
                            {
                                parseFloat(servicePaymentLimit).toLocaleString('en-US', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) || ''
                            }
                        </b>. Si aprueba esta gestión, el operador deberá completar la información del <b>comprobante</b>.
                    </Alert>
                </Grid>
            )}
            {/* {(!requiresAdministrativeApproval)&&( */}
            <SlipSection useFetchInit={useFetchInit} readOnlyMode={readOnlyMode}/>
            {/* )} */}
        </>
    )
}
